import type { ReviewOrderState } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/** 주문 id 로 찾기 쉽게 Map 으로 바꾼다. 주문이 없으면 부르지 않는다. */
export const useReviewStatesForOrdersQuery = (orderIds: readonly string[]) =>
  trpc.myReviews.statesForOrders.useQuery(
    { orderIds: [...orderIds] },
    {
      enabled: orderIds.length > 0,
      select: (states): ReadonlyMap<string, ReviewOrderState> =>
        new Map(states.map((state) => [state.orderId, state])),
    },
  );
